import { Route, Routes } from 'react-router';

import SubCategoryEdit from './SubCategoryEdit';
import SubCategoryList from './SubCategoryList';

function SubCategoryModule() {
  return (
    <Routes>
      <Route path="" element={<SubCategoryList />} />
      <Route path=":id" element={<SubCategoryEdit />} />
    </Routes>
  );
}

export default SubCategoryModule;
